import { mapState, mapMutations } from "vuex";
import { conversion, countDownS } from "@/tool";
import * as Validation from "@/utils/validation";

import {
  sureBindQQApi,
  sendBindPhoneCode,
  sureBindEmail,
  sendResetCode,
  resetPhonePassword,
  promoterInvitation,
  api_SyncSteamUserInfo,
  api_SetNickname,
  api_UploadAvatar,
} from "@/api";
import * as apis from "@/api";

import { ConfirmModal, use_confirm_modal } from "@/partials/confirm_modal";
import CustomButton from "@/partials/custom_button";
import { CustomBlockTitle } from "@/partials/custom_block_title";

import Avatar from "@/components/avatar";
import Picture from "@/components/picture";
import Button from "@/components/button";
import { Modal, use_modal } from "@/components/modal";
import InteractivePanel from "@/components/interactive_panel";
import Cookies from "@/utils/cookie";
import SteamTradeUrlModal from "@/pages/user/components/steam_trade_url_modal";
export default {
  components: {
    "p-confirm-modal": ConfirmModal,
    "p-custom-button": CustomButton,
    "p-custom-block-title": CustomBlockTitle,

    "c-avatar": Avatar,
    "c-picture": Picture,
    "c-button": Button,
    "c-modal": Modal,
    "c-interactive-panel": InteractivePanel,
    "steam-trade-url-modal": SteamTradeUrlModal,
  },

  filters: {
    conversion,
    countDownS,
  },

  data() {
    return {
      SteamInSync: false,
      flag: {
        tradeURL: false,
        qqFlag: false,
        douyinFlag: false,
        invitationCodeFlag: false,
        invitationModifyChecking: false,
        mailFlag: false,
      },
      modify: {
        qq: "",
        douyin: "",
        invitationCode: "",
        mail: "",
        tradeURL: "",
      },
      modifyModal: {
        phoneNumberFlag: false,
        phoneNumberFrom: {
          oldpassword: "",
          oldpassword_error: "",
          password: "",
          password_error: "",
          is_loading: false,
        },
      },

      modifyTradeModal: {
        flag: false,
        url: "",
      },
      modifyNameModal: {
        flag: false,
        nickname: "",
      },
      modalBindPhone: false,
      modalBindEmail: false,
      modalFans: false,
      //绑定手机号
      bindPhoneData: {
        phone: "",
        code: "",
        captchaCode: "",
        time: 61,
        captcha: 462354763,
        flag: false,
        setFlag: true,
      },
      bindEmailData: {
        email: "",
        code: "",
        time: 61,
        setFlag: true,
      },
      fansCardList: [],
      checkindex: -1,
      checkId: 0,

      /** 修改密码 模态框 */
      change_password_modal: use_modal(),
      visibleSubAccount: {
        flag: false,
        uid: null,
        subProfile: {},
      },
      subAccountList: [],
    };
  },

  computed: {
    ...mapState(["user", "config", "information"]),

    expiredAt() {
      const expired_time = new Date(this.user.expiredAt).getTime();
      const now_time = new Date().getTime();

      return expired_time > now_time;
    },
  },
  created() {
    this.getSubAccount();
  },
  methods: {
    ...mapMutations(["setInfo", "setPayModal"]),

    conversion,

    //绑定qq账号
    sureBindQQ() {
      if (!/[\d]{6,12}/.test(this.modify.qq))
        return this.$toast.error("请输入正确的QQ号");
      sureBindQQApi({ val: this.modify.qq }).then((res) => {
        if (res.data.code === 0) {
          this.$toast.success("绑定成功");
          this.$store.commit("setInfo");
          this.flag.qqFlag = false;
          this.modify.qq = "";
        } else {
          this.$toast.error(res.data.msg);
        }
      });
    },

    /**
     * 获取手机验证码
     * @param prop 不同方式获得手机号验证码
     * @param mobile mobile数据
     * @returns {boolean}
     */
    getMobileCode(prop, mobile) {
      let api = {
        sendBindPhoneCode, //绑定手机号发送验证码
        sendResetCode,
      };
      if (!/^1[0-9]{10}$/.test(mobile.phone)) {
        return this.$toast.error("请输入正确的手机号");
      }
      if (prop === "sendBindPhoneCode") {
        /*绑定手机发送验证码需要图形验证码*/
        if (!mobile.captchaCode) return this.$toast.error("请输入图形验证码");
      }
      if (mobile.time !== 61) return;
      api[prop]({
        val: mobile.phone,
        captcha: mobile.captchaCode,
      }).then((res) => {
        if (res.data.code === 0) {
          this.timeCounter(mobile);
        } else {
          this.$toast.error(res.data.msg);
        }
      });
    },

    /** 绑定邮箱 */
    async sureBindEmail() {
      if (!/^[\w]{6,11}@qq.com$/.test(this.modify.mail))
        this.$toast.error("请输入正确的邮箱");

      const sure_bind_email_response = await sureBindEmail({
        val: this.modify.mail,
      });

      if (sure_bind_email_response.data.code !== 0) {
        this.$toast.error(message);
        return;
      }

      this.$toast.success(sure_bind_email_response.data.msg);
      this.flag.mailFlag = false;
      this.$store.commit("setInfo");
    },

    /** 手机号修改密码 */
    async ChangePassword() {
      if (this.modifyModal.phoneNumberFrom.is_loading) return;

      const { oldpassword, password } = this.modifyModal.phoneNumberFrom;

      if (!oldpassword) {
        this.modifyModal.phoneNumberFrom.oldpassword_error = "旧密码不能为空";
        return this.$toast.error("请输入旧密码");
      }

      // 验证密码
      if (!Validation.password(password)) {
        this.modifyModal.phoneNumberFrom.password_error =
          "密码必须为长度6~16,英文字母或数字或符号组合";
        return this.$toast.error("密码必须为长度6~16,英文字母或数字或符号组合");
      }

      this.modifyModal.phoneNumberFrom.is_loading = true;
      let reset_phone_password_response = await resetPhonePassword({
        oldpassword: oldpassword,
        password: password,
      });

      this.modifyModal.phoneNumberFrom.is_loading = false;

      const message = reset_phone_password_response.data.msg;

      // 修改失败
      if (reset_phone_password_response.data.code !== 0) {
        this.modifyModal.phoneNumberFrom.password_error = message;
        this.$toast.error(message);
        return;
      }

      this.$toast.success(message);
      this.modifyModal.phoneNumberFlag = false;

      if (this.user.nickname) {
        this.setInfo();
        //this.$router.push({ name: 'home' });
      }

      this.$store.commit("setInfo");
      this.change_password_modal.toggle();
    },

    SyncSteamInfo() {
      if (this.SteamInSync) return;

      this.SteamInSync = true;
      api_SyncSteamUserInfo().then((res) => {
        if (res.data.code === 0) {
          this.setInfo();
          this.$toast.success(res.data.msg);
        } else {
          this.$toast.error(res.data.msg);
        }
        this.SteamInSync = false;
      });
    },
    //退出登录
    logOut() {
      this.loginModal.isLoginSuccess = null;
      //关闭mpCaseHub的websocket连接
      this.$mpCaseHub.onConnected = null;
      this.$mpCaseHub.onReconnected = null;
      this.$mpCaseHub.conn.off("MPCaseFinished");
      //关闭caseBattleHub的websocket连接
      this.$caseBattleHub.onConnected = null;
      this.$caseBattleHub.onReconnected = null;
      this.$caseBattleHub.conn.off("GCUpdateRoomRecv");
      this.$caseBattleHub.conn.off("GCChallengeFailedRecv");
      sessionStorage.clear();
      sessionStorage.removeItem("user");
      Cookies.removeToken();
      localStorage.removeItem("lastCreateNewCase");
      this.setInfo();
      //this.$refs.sidebar.set_active_offer_count(0);
      this.$router.push({ name: "home" });
    },

    //验证码倒计时
    timeCounter(data) {
      data.time = 60;
      let id = setInterval(() => {
        data.time -= 1;
        if (data.time === 0) {
          data.time = 61;
          clearInterval(id);
        }
      }, 1000);
    },

    //设置邀请码
    async checkInvitationModify() {
      if (this.flag.invitationModifyChecking || this.flag.invitationCodeFlag) return;

      this.flag.invitationModifyChecking = true;
      try {
        const res = await apis.checkInvitationModify();
        if (res.data.code === 0) {
          this.modify.invitationCode = "";
          this.flag.invitationCodeFlag = true;
        } else {
          this.$toast.error(res.data.msg);
        }
      } catch (error) {
        this.$toast.error("检查邀请码修改条件失败，请稍后重试");
      } finally {
        this.flag.invitationModifyChecking = false;
      }
    },

    cancelInvitationModify() {
      this.flag.invitationCodeFlag = false;
      this.modify.invitationCode = "";
    },

    bindCode() {
      let value = this.modify.invitationCode;
      if (!value) {
        value = "www";
      }
      if (/http:|https:/gi.test(value)) {
        value = /code=(\w+)/i.exec(value)[1];
      }
      promoterInvitation({ val: value }).then((res) => {
        if (res.data.code === 0) {
          this.$toast.success(res.data.msg);
          this.flag.invitationCodeFlag = false;
          this.modify.invitationCode = "";
          this.setInfo();
        } else {
          this.$toast.error(res.data.msg);
        }
      });

    },

    /** 更新用户信息 */
    async user_info_sync() {
      const update_avatar_response = await apis.updateAvatar();

      if (update_avatar_response.data.code !== 0) {
        this.$toast.error(update_avatar_response.data.msg);

        return;
      }

      this.$toast.success("同步成功");
      this.setInfo();
    },

    submitChangeName() {
      const data = {
        val: this.modifyNameModal.nickname,
      };
      if (this.modifyNameModal.nickname.length > 10) {
        this.$toast.success("长度不可超过10个中文字或20个字母");
        return;
      }
      if (!/^[\u4e00-\u9fa5A-Za-z0-9]+$/.test(this.modifyNameModal.nickname)) {
        this.$toast.error("昵称只能包含中文、英文和数字");
        return;
      }
      api_SetNickname(data).then((res) => {
        if (res.data.code == 0) {
          this.$toast.success(res.data.msg);
          this.modifyNameModal.flag = false;
          this.setInfo();
        } else {
          this.$toast.error(res.data.msg);
        }
      });
    },

    async handleUploadAvatar(file) {
      const isWH = await this.checkImageWH(file, 600, 600);
      if (file.size > 1024 * 1024 * 1) {
        this.$toast.error("请上传长和高不高600像素且大小低于1M的图片");
        return;
      }

      if (!isWH) {
        this.$toast.error("请上传长和高不高600像素且大小低于1M的图片");
        return;
      }

      var form = new FormData(); // 实例化一个formData，用来做文件上传
      form.append("pic", file);
      api_UploadAvatar(form).then((res) => {
        if (res.data.code == 0) {
          this.setInfo();
          this.$toast.success("修改成功");
        } else {
          this.$toast.error(res.data.msg);
        }
      });

      return false;
    },
    checkImageWH(file, width, height) {
      // 参数分别是上传的file，想要限制的宽，想要限制的高
      return new Promise(function (resolve, reject) {
        let filereader = new FileReader();
        filereader.onload = (e) => {
          let src = e.target.result;
          const image = new Image();
          image.onload = function () {
            if (this.width >= width && this.height >= height) {
              // 上传图片的宽高与传递过来的限制宽高作比较，超过限制则调用失败回调
              resolve(false);
            } else {
              resolve(true);
            }
          };
          image.onerror = reject;
          image.src = src;
        };
        filereader.readAsDataURL(file);
      });
    },
    async getSubAccount() {
      const res = await apis.api_GetSubAccount();
      // console.log(11111,res.data.data)
      this.subAccountList = res.data.data;
    },
    async getSubProfile() {
      const res = await apis.api_GetSubProfileByUid({
        uid: this.visibleSubAccount.uid,
      });
      if (res.data.code === 0) {
        this.visibleSubAccount.subProfile = res.data.data;
      } else {
        this.$toast.error(res.data.msg);
      }
    },
    async addSubAccount() {
      if (!this.visibleSubAccount.subProfile.uid) {
        this.$toast.error("请先搜索用户是否存在");
        return;
      }
      const res = await apis.api_AddSubAccount({
        val: this.visibleSubAccount.subProfile.uid,
      });
      console.log(111, res);
      if (res.data.code === 0) {
        this.$toast.success("绑定成功");
        this.visibleSubAccount = {
          flag: false,
          uid: null,
          subProfile: {},
        };
        this.getSubAccount();
      } else {
        this.$toast.error(res.data.msg);
      }
    },
    async removeSubAccount(uid) {
      const res = await apis.api_RemoveSubAccount({ uid });
      if (res.data.code === 0) {
        this.$toast.success("解绑成功");
        this.getSubAccount();
      } else {
        this.$toast.error(res.data.msg);
      }
    },
  },
};
